import OnboardingCheckpointCards from '@/features/onboarding/components/OnboardingCheckpointCards';
import OnboardingCheckpointGrid from '@/features/onboarding/components/OnboardingCheckpointGrid';
import OnboardingCheckpointSearchBar from '@/features/onboarding/components/OnboardingCheckpointSearchBar';
import OnboardingConfigurationStatusPanel from '@/features/onboarding/components/OnboardingConfigurationStatusPanel';
import OnboardingFlowHeader from '@/features/onboarding/components/OnboardingFlowHeader';
import SubjectOnboardingFlowShell from '@/features/onboarding/components/SubjectOnboardingFlowShell';

import SiteComplianceCheckpointConfigDrawer from './SiteComplianceCheckpointConfigDrawer';
import SiteComplianceOnboardConfigureForm from './SiteComplianceOnboardConfigureForm';
import SiteComplianceOnboardDetails from './SiteComplianceOnboardDetails';
import { useSiteComplianceOnboardController } from './useSiteComplianceOnboardController';

const SiteComplianceOnboardPage = () => {
  const {
    checkpointConfigProps,
    checkpointListProps,
    checkpointSearchProps,
    configureFormProps,
    detailsProps,
    emptyStateMessage,
    hasLatestConfiguration,
    headerProps,
    isMobileViewport,
    statusProps,
  } = useSiteComplianceOnboardController();

  return (
    <SubjectOnboardingFlowShell
      checkpointConfig={
        <SiteComplianceCheckpointConfigDrawer {...checkpointConfigProps} />
      }
      checkpointSearch={
        checkpointSearchProps ? (
          <OnboardingCheckpointSearchBar {...checkpointSearchProps} />
        ) : null
      }
      desktopCheckpointList={
        <OnboardingCheckpointGrid {...checkpointListProps} />
      }
      emptyStateMessage={emptyStateMessage}
      hasConfiguration={hasLatestConfiguration}
      header={<OnboardingFlowHeader {...headerProps} />}
      isMobileViewport={isMobileViewport}
      mobileCheckpointList={
        <OnboardingCheckpointCards {...checkpointListProps} />
      }
      subjectDetails={<SiteComplianceOnboardDetails {...detailsProps} />}
      subjectSelection={
        <SiteComplianceOnboardConfigureForm {...configureFormProps} />
      }
      subjectStatus={
        statusProps ? (
          <OnboardingConfigurationStatusPanel {...statusProps} />
        ) : null
      }
    />
  );
};

export default SiteComplianceOnboardPage;
